<template>
    <div class="ml-20">

        <a-list item-layout="horizontal">
            <a-list-item>
                <a-list-item-meta>
                    <div slot="title">
                        <span class="mt-5 mb-10" style="color: #610C9F !important;">
                            Privacy and Policy / Term of Use
                        </span>
                    </div>
                    <div slot="description">
                        <span class="font-web" style="font-size: 14px;">
                            เงื่อนไข และข้อกำหนดต่างๆ ของ Application
                        </span>
                    </div>
                    <a-avatar :style="{ backgroundColor: '#610C9F' }" slot="avatar" shape="square" :size="55"
                        icon="safety" />
                </a-list-item-meta>
            </a-list-item>
        </a-list>

        <a-row :gutter="[16, 16]" class="text-center">
            <a-col class="text-center" :xs="{ span: 24 }" :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
                <a-result>
                    <template #icon>
                        <a-avatar class="mb-20" style="backgroundColor:#fdb913" :size="40">
                            <h4 style="color: #502b80;">1</h4>
                        </a-avatar>
                        <MobileFrame title="Overview" name="bg-privacy" />
                    </template>
                    <template #title>
                        <h5 class="mb-10 font-web"><i>Privacy and Policy</i></h5>
                        <p class="m-0 font-web" style="color: #7C81AD;"> </p>
                    </template>
                    
                </a-result>
            </a-col>
            <a-col class="text-center" :xs="{ span: 24 }" :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
                <a-result>
                    <template #icon>
                        <a-avatar class="mb-20" style="backgroundColor:#fdb913" :size="40">
                            <h4 style="color: #502b80;">2</h4>
                        </a-avatar>
                        <MobileFrame title="Overview" name="bg-term" />
                    </template>
                    <template #title>
                        <h5 class="mb-10 font-web"><i>Term of Use</i></h5>
                        <p class="m-0 font-web" style="color: #7C81AD;"> </p>
                    </template>
                    
                </a-result>
            </a-col>
        </a-row>

    </div>
</template>

<script>
import MobileFrame from '../MobileFrame.vue';

export default {
    components: {
        MobileFrame,
    },
    data() {
        return {}
    }
}
</script>